'use strict';

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol['for'] && Symbol['for']("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _makeComponentIntl = require('common/utils/make-component-intl');

var _makeComponentIntl2 = _interopRequireDefault(_makeComponentIntl);

var _hfReactHelper = require('common/utils/hf-react-helper');

var _hfReactHelper2 = _interopRequireDefault(_hfReactHelper);

var _constants = require('signer/components/common/signature-modal/constants');

var _constants2 = _interopRequireDefault(_constants);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _button = require('common/components/button');

var _button2 = _interopRequireDefault(_button);

var _bubbleMenu = require('common/components/bubble-menu');

var _bubbleMenu2 = _interopRequireDefault(_bubbleMenu);

var _editSignatureModal = require('signer/components/common/signature-modal/edit-signature-modal');

var _editSignatureModal2 = _interopRequireDefault(_editSignatureModal);

var _logo = require('./logo.jsx');

var _logo2 = _interopRequireDefault(_logo);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

// TODO: HelloFax & HelloSign header files should NOT be together - separate this stuff (CC)
// In-app top bar
var AppTopBar = _react2['default'].createClass({
    displayName: 'AppTopBar',


    propTypes: {
        'siteCode': _react.PropTypes.string.isRequired, // S or F
        'showUpgradeButton': _react.PropTypes.bool,
        'emailAddress': _react.PropTypes.string,
        'name': _react.PropTypes.string,
        'primarySignatureGuid': _react.PropTypes.string,
        'numDocsLeft': _react.PropTypes.oneOfType([_react.PropTypes.number, _react.PropTypes.string]),
        'numTemplatesLeft': _react.PropTypes.oneOfType([_react.PropTypes.number, _react.PropTypes.string]),
        'numFaxPagesLeft': _react.PropTypes.oneOfType([_react.PropTypes.number, _react.PropTypes.string]),
        'minimalDisplay': _react.PropTypes.bool, // Only show the account menu (default is false)
        'disableAccountMenu': _react.PropTypes.bool, // Disable the account menu dropdown menu (default is false)
        'hideEmailAddress': _react.PropTypes.bool, // Hide the email address (default is false)
        'signatureModalProps': _react.PropTypes.object // Signature modal props
    },

    //  ----  LIFECYCLE  ----------------------------------

    getDefaultProps: function getDefaultProps() {
        return {
            'showUpgradeButton': true,
            'minimalDisplay': false,
            'hideEmailAddress': false,
            'disableAccountMenu': false
        };
    },

    getInitialState: function getInitialState() {
        return {
            'signDocsMenuIsShown': false,
            'accountMenuIsShown': false,
            'signatureModalIsShown': false,
            'signatureModalTab': _constants2['default'].TAB_SAVED
        };
    },

    //  ----  BEHAVIOR  -----------------------------------

    showHowItWorks: function showHowItWorks() {
        var site = _hfReactHelper2['default'].HfSites.getSite(this.props.siteCode);
        document.location = _hfReactHelper2['default'].urlHelper('account/sendDemo', site);
    },

    showSignatureModal: function showSignatureModal(evt) {

        evt.preventDefault();
        evt.stopPropagation();

        this.setState({
            'signatureModalIsShown': true
        });

        this.hideAccountMenu();
    },

    hideSignatureModal: function hideSignatureModal(evt) {
        this.setState({
            'signatureModalIsShown': false,
            'signatureModalTab': _constants2['default'].TAB_SAVED
        });
    },

    showInviteFriendsModal: function showInviteFriendsModal(evt) {

        evt.preventDefault();

        var site = _hfReactHelper2['default'].HfSites.getSite(this.props.siteCode);
        var url = _hfReactHelper2['default'].urlHelper('home/inviteFriends', site);

        $.fancybox({
            'type': 'iframe',
            'showCloseButton': false,
            'scrolling': 'no',
            'href': url,
            'padding': 0,
            'margin': 0,
            'autoDimensions': true,
            onStart: function onStart() {
                $('#fancybox-overlay').addClass('m-fancybox-modal-overlay settings-modal invite-friends is-hidden');
                $('#fancybox-wrap').addClass('m-fancybox-modal-wrap settings-modal invite-friends is-hidden');
                $('#fancybox-inner').addClass('m-fancybox-modal-inner settings-modal invite-friends');
            },
            onComplete: function onComplete() {
                $.fancybox.center();
                $('#fancybox-overlay, #fancybox-wrap').removeClass('is-hidden');
            },
            onClosed: function onClosed() {
                $('#fancybox-overlay, #fancybox-wrap, #fancybox-inner').attr('class', '');
            }
        });

        this.hideAccountMenu();
    },

    toggleSignDocsMenu: function toggleSignDocsMenu() {
        this.setState({
            'signDocsMenuIsShown': !this.state.signDocsMenuIsShown
        });
    },

    showAccountMenu: function showAccountMenu() {
        if (!this.props.disableAccountMenu) {
            this.setState({ 'accountMenuIsShown': true });
        }
    },

    hideAccountMenu: function hideAccountMenu() {
        if (!this.props.disableAccountMenu) {
            this.setState({ 'accountMenuIsShown': false });
        }
    },

    updatePrimarySignature: function updatePrimarySignature(signature) {

        window.primarySignatureGuid = signature ? signature.guid : void 0;

        if (this.state.signatureModalTab == _constants2['default'].TAB_SAVED) {

            // Mark the current signature as primary and close the modal
            signature.markAsPrimary().then(function () {
                this.hideSignatureModal();
            }.bind(this))['catch'](function (err) {
                // Fail silently
                console.error("Could not mark signature as primary", err);
            }.bind(this));
        } else {

            // Show the saved signature tab after a new one has been created
            this.setState({
                'signatureModalTab': _constants2['default'].TAB_SAVED
            });
        }
    },

    onSignatureModalTabSelected: function onSignatureModalTabSelected(tabId) {
        this.setState({
            'signatureModalTab': tabId
        });
    },

    //  ----  RENDERING  ----------------------------------

    renderAccountMenu: function renderAccountMenu(site) {
        var settingsUrl = _hfReactHelper2['default'].urlHelper('home/myAccount', site);
        var logoutUrl = _hfReactHelper2['default'].urlHelper('account/logOut', site);
        var signatureGuid;
        var freeDocsLink;

        if (window.primarySignatureGuid === null) {
            // In this case we don't have a primary signature because it just got deleted
            signatureGuid = null;
        } else {
            signatureGuid = window.primarySignatureGuid || this.props.primarySignatureGuid;
        }

        var items = [undefined, undefined, _jsx('a', {
            href: settingsUrl
        }, void 0, 'Settings'), _jsx('a', {
            href: logoutUrl
        }, void 0, 'Logout')];

        if (_hfReactHelper2['default'].HfSites.isHelloSign(site)) {

            // Signature
            var name;
            var sig;
            var sigClassNames = (0, _classnames2['default'])({
                'm-app-topbar--menu--signature--sig': true,
                'no-sig': !signatureGuid,
                'l-margin-t-20': !this.props.name
            });
            if (this.props.name) {
                name = _jsx('div', {
                    className: 'm-app-topbar--menu--signature--name'
                }, void 0, this.props.name);
            }
            if (signatureGuid) {
                sig = _jsx('div', {
                    className: sigClassNames
                }, void 0, _jsx('div', {
                    className: 'm-app-topbar--menu--signature--image'
                }, void 0, _jsx('img', {
                    src: _hfReactHelper2['default'].urlHelper('attachment/view?sig_guid=' + signatureGuid, site)
                })), _jsx('div', {
                    className: 'm-app-topbar--menu--signature--edit'
                }, void 0, _jsx('a', {
                    href: 'javascript:;',
                    onClick: this.showSignatureModal
                }, void 0, 'Edit signature')));
            } else {
                sig = _jsx('div', {
                    className: sigClassNames,
                    onClick: this.showSignatureModal
                }, void 0, _jsx('img', {
                    src: require('./plus_icon@2x.png')
                }), _jsx('span', {}, void 0, 'Create a signature'));
            }
            items[0] = _jsx('div', {
                className: 'm-app-topbar--menu--signature'
            }, void 0, name, sig);

            // HS Credits
            var numDocsLeft = this.props.numDocsLeft === null ? 'Unlimited' : this.props.numDocsLeft;
            var numTemplatesLeft = this.props.numTemplatesLeft === null ? 'Unlimited' : this.props.numTemplatesLeft;
            if (this.props.showUpgradeButton) {
                freeDocsLink = _jsx('a', {
                    href: '',
                    onClick: this.showInviteFriendsModal
                }, void 0, 'Get free documents');
            }

            items[1] = _jsx('div', {
                className: 'm-app-topbar--menu--credits'
            }, void 0, _jsx('div', {
                className: 'm-app-topbar--menu--credits--title'
            }, void 0, 'REMAINING CREDITS'), _jsx('div', {
                className: 'm-app-topbar--menu--credits--line'
            }, void 0, numDocsLeft + ' document' + (numDocsLeft !== 1 ? 's' : '')), _jsx('div', {
                className: 'm-app-topbar--menu--credits--line'
            }, void 0, numTemplatesLeft + ' template' + (numTemplatesLeft !== 1 ? 's' : '')), freeDocsLink);
        } else {

            // HF Credits
            var getFreePagesUrl = _hfReactHelper2['default'].urlHelper('account/gettingStarted', site);
            var numFaxPagesLeft = this.props.numFaxPagesLeft === null ? 'Unlimited' : this.props.numFaxPagesLeft;
            items[1] = _jsx('div', {
                className: 'm-app-topbar--menu--credits'
            }, void 0, _jsx('div', {
                className: 'm-app-topbar--menu--credits--title'
            }, void 0, 'REMAINING CREDITS'), _jsx('div', {
                className: 'm-app-topbar--menu--credits--line'
            }, void 0, numFaxPagesLeft + ' fax page' + (numFaxPagesLeft !== 1 ? 's' : '')), _jsx('a', {
                href: getFreePagesUrl
            }, void 0, 'Get free pages'));
        }

        var cnames = (0, _classnames2['default'])({
            'account-menu': true,
            'with-upgrade': this.props.showUpgradeButton,
            'is-hidden': !this.state.accountMenuIsShown
        });

        return _jsx(_bubbleMenu2['default'], {
            items: items,
            direction: 'bottom',
            className: cnames
        }, 'account-menu-popup');
    },

    signatureModalProps: function signatureModalProps() {
        var app = this.props.app || window.app;
        if (this.props.signatureModalProps.settings) {
            app.isMobile = false;
            app.user.settings = Object.assign(app.user.settings || {}, this.props.signatureModalProps.settings);
        }
        return {
            'app': app,
            'buttonText': this.state.signatureModalTab === _constants2['default'].TAB_SAVED ? 'Select' : 'Save',
            'emailGuid': this.props.signatureModalProps.emailGuid,
            'emailUploadAddress': this.props.signatureModalProps.emailUploadAddress,
            'type': this.props.signatureModalProps.signatureType,
            'onComplete': this.updatePrimarySignature,
            'onSelectTab': this.onSignatureModalTabSelected,
            'onClose': this.hideSignatureModal,
            'initialTab': this.state.signatureModalTab,
            'intl': this.props.intl
        };
    },

    render: function render() {

        var isHf = _hfReactHelper2['default'].HfSites.isHelloFax(this.props.siteCode);
        var site = _hfReactHelper2['default'].HfSites.getSite(this.props.siteCode);
        var homeUrl = _hfReactHelper2['default'].urlHelper('home/index', site);
        var logoUrl = isHf ? require('./logo_hf@2x.png') : require('./logo@2x.png');
        var signDocs;
        var seeHowBtn;
        var upgradeBtn;
        var acctMenu;
        var signDocsMenu;
        var emailAddressLink;
        var signatureModal;

        var topBarMenuClasses = (0, _classnames2['default'])({
            'm-app-topbar--menu': true,
            'is-disabled': this.props.disableAccountMenu
        });

        var meAndOthersParams = 'me=1';

        if (!this.props.minimalDisplay) {

            if (isHf) {

                seeHowBtn = _jsx(_button2['default'], {
                    buttonText: 'See how it works',
                    buttonLink: '',
                    buttonColor: 'white',
                    buttonTextColor: 'ashen',
                    buttonClass: 'border-1-ashen',
                    buttonModuleClass: 'm-app-topbar--see-how-btn',
                    onClick: this.showHowItWorks
                }, 'see-how-it-works-button');
            } else {

                if (this.state.signDocsMenuIsShown) {
                    var items = [_jsx('a', {
                        href: _hfReactHelper2['default'].urlHelper('sign', site)
                    }, void 0, 'Just me'), _jsx('a', {
                        href: _hfReactHelper2['default'].urlHelper('home/request?' + meAndOthersParams, site)
                    }, void 0, 'Me & others'), _jsx('a', {
                        href: _hfReactHelper2['default'].urlHelper('home/request', site)
                    }, void 0, 'Just others')];
                    signDocsMenu = _jsx(_bubbleMenu2['default'], {
                        items: items,
                        direction: 'bottom',
                        className: 'signdocs-menu'
                    }, 'sign-docs-popup');
                }

                signDocs = _jsx('div', {
                    className: 'm-app-topbar--signdocs',
                    onMouseEnter: this.toggleSignDocsMenu,
                    onMouseLeave: this.toggleSignDocsMenu
                }, void 0, _jsx('div', {
                    className: 'm-app-topbar--signdocs--title'
                }, void 0, _jsx('span', {
                    className: 'm-app-topbar--signdocs--icon'
                }, void 0, _jsx('img', {
                    className: 'm-app-topbar--signdocs--icon--img',
                    src: require('./signdoc_icon@2x.png')
                })), _jsx('span', {
                    className: 'm-app-topbar--signdocs--title--text'
                }, void 0, 'Sign documents')), signDocsMenu);
            }
        }

        if (!this.props.minimalDisplay && this.props.showUpgradeButton) {
            upgradeBtn = _jsx('a', {
                href: _hfReactHelper2['default'].urlHelper('info/pricing', site),
                className: 'm-button bg-cerulean m-app-topbar--upgrade-btn hbg-castle-rock hc-white c-white progress-button state-loading'
            }, void 0, 'Upgrade');
        }

        if (!this.props.hideEmailAddress) {

            // Render the account menu dropdown
            acctMenu = this.renderAccountMenu(site);

            // Hidden signature modal
            if (!isHf && this.state.signatureModalIsShown) {
                signatureModal = _react2['default'].createElement(_editSignatureModal2['default'], this.signatureModalProps());
            }

            // Render the email address link
            emailAddressLink = _jsx('div', {
                className: 'm-app-topbar--menu--title m-app-topbar--menu--title-email'
            }, void 0, _jsx('span', {
                className: 'm-app-topbar--menu--title--text'
            }, void 0, this.props.emailAddress), _jsx('span', {
                className: 'm-app-topbar--menu--title--icon'
            }, void 0, _jsx('img', {
                src: require('./menu_arrow@2x.png')
            })));
        }

        return _jsx('div', {
            className: 'm-app-topbar'
        }, void 0, signatureModal, _jsx(_logo2['default'], {
            href: homeUrl,
            src: logoUrl,
            alt: isHf ? 'HelloFax' : 'HelloSign',
            width: '229',
            height: '35'
        }), _jsx('div', {
            className: 'm-app-topbar--actions'
        }, void 0, signDocs, seeHowBtn, upgradeBtn, _jsx('div', {
            className: topBarMenuClasses,
            onMouseEnter: this.showAccountMenu,
            onMouseLeave: this.hideAccountMenu
        }, void 0, emailAddressLink, acctMenu)));
    }
});

module.exports = (0, _makeComponentIntl2['default'])(AppTopBar);


/*****************
 ** WEBPACK FOOTER
 ** ./src/hellosign/components/app/header/index.jsx
 ** module id = 636
 ** module chunks = 0
 **/